// AMBIENTE DSN

import { ConfiguracaoAndroid } from "src/app/core/modelos/Android/ConfiguracaoAndroid";
import { ConfigImpressora } from "src/app/core/modelos/ConfigImpressora";

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export class environment {
  static appVersion = require("../../package.json").version + "-[DSN]";

  static production = false;

  static baseApiUrlDiscovery = "https://maestro.mda-dsn.alt-noprd-clt01.alterdatasoftware.com.br/";

  static baseApiModuleFinacial = 53010;
  static baseApiModuleLogistic = 54010;
  static baseApiModulePurchase = 55010;
  static baseApiModuleTributary = 56010;
  static baseApiModuleHumanResources = 52010;
  static baseApiModuleReportView = 10003;
  static baseApiModuleInfraStructure = 10002;
  static baseApiModuleSupply = 57010;
  static baseApiModuleCRM = 58010;
  static baseApiModuleSales = 59010;
  static baseApiModulePrice = 60010;
  static baseApiModuleEcommerce = 61010;
  static baseApiModuleIntegracao = 63010;
  static baseApiModuleMisc = 62010;
  
  static codigoParaVerificacaoDoReceber: number = 2380;

  static baseUrlConciliare = "https://conciliare-hml.alterdata.com.br/autenticacao.html";

  static baseApiUrlCashBack = "https://apicashback.quickon.com.br/";
  static baseApiUrlPix = "https://apiv2.quickonpay.com.br/";

}
